// extracted by mini-css-extract-plugin
export default {"wrapper":"GoUpButton_wrapper__ZD9xs","button":"GoUpButton_button__Y-kii"};